import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Spinner from "react-bootstrap/Spinner";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PSignupModal from "../PSignupModal";
import PostsContent from "../Post/posts-contents";
import MediaContent from "../Post/media-contents";
import ShopContents from "../Post/shop-contents";
import PCreatePost from "../PCreatePost";
import PStatistics from "../PStatistics";
import TickSmall from "../../images/tick_small_edit.png";
import Avatar from "../Avatar";
import moment from "moment";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

/* DARK MODE */
import PRainbowToast from "../PRainbowToast";
import {
    s3Link,
    ROLES,
    VERIFIED_STATUS,
    FOLLOW_STATUS,
} from "../../utils/constants";
import currency from "currency.js";
import { connect, useDispatch } from "react-redux";
import MetaTags from "react-meta-tags";

import "./style.scss";
import CloseButton from "../CloseButton";
import { calculatePercentage } from "../../utils/helper";
import {
    setStashSelectedR,
    setStashSort,
    setStashType,
    setFilterToDate,
} from "../../../redux/actions/stash";
import useOnlineHook from "../../utils/useOnlineHook";
import { addChunkOnlinePresence } from "../../../redux/actions/user";
import CountDownTimer from "../CountDownTimer";
import { Badge, useMediaQuery } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import DefaultWidget from "../../Widgets/SU/Default";
import DefaultPUWidget from "../../Widgets/PU/Default";

function tabProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            className="full-width-tabpanel"
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const ReadMoreLess = ({ text, maxLength }) => {
    const [isFullTextVisible, setIsFullTextVisible] = useState(false);

    const toggleReadMore = () => {
        setIsFullTextVisible(!isFullTextVisible);
    };

    let tmpText = "";
    if (text.length <= maxLength) {
        tmpText = text;
    } else {
        // Find the last space within the maxLength
        const lastSpaceIndex = text.lastIndexOf(" ", maxLength);

        // If no space is found, truncate at the maxLength
        tmpText =
            lastSpaceIndex !== -1
                ? text.slice(0, lastSpaceIndex)
                : text.slice(0, maxLength);
    }

    const truncatedText = isFullTextVisible ? text : tmpText;

    return (
        <div>
            <div
                style={{ whiteSpace: "pre-wrap", display: "inline" }}
                dangerouslySetInnerHTML={{ __html: truncatedText }}
            />
            {text.length > maxLength && (
                <span>
                    {!isFullTextVisible ? "..." : ""}
                    <span
                        className="text-blue ml-1"
                        style={{ cursor: "pointer" }}
                        onClick={toggleReadMore}
                    >
                        {isFullTextVisible ? "Less" : "More"}
                    </span>
                </span>
            )}
        </div>
    );
};

const PUPageContent = ({
    user,
    getUserInformation,
    darkmode,
    activePost,
    userStore,
}) => {
    useOnlineHook();

    const isMobile = useMediaQuery("(max-width: 899px)");

    const dispatch = useDispatch();

    const [link, setLink] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [show, setShow] = useState(false);
    const [refetch, setRefetch] = useState(false);
    const [isPu, setIsPu] = useState(false);
    const [key, setKey] = useState(0);
    const [fundLoading, setFundLoading] = useState(false);
    const [funds, setFunds] = useState(0);
    const [timeLeft, setTimeLeft] = useState("");
    const [promoUrl, setPromoUrl] = useState({});
    const [savings, setSavings] = useState("");
    const [onShop, setOnShop] = useState(false);

    const handleChangeTab = (event, newValue) => {
        const containerHeight = document
            .getElementById("pu-content-container")
            .getBoundingClientRect().height;
        $("#pu-content-container").height(containerHeight);

        setKey(newValue);
    };

    const userInformation = JSON.parse(localStorage.getItem("user"));

    const isLoggedIn = localStorage.getItem("loggedin_user");

    useEffect(() => {
        let mounted = true;
        window.scrollTo(0, 0);
        setLink(window.location.href);
        const pathname = window.location.pathname.replace("/");
        if (pathname === userInformation.login) {
            setIsPu(false);
        } else {
            setIsPu(true);
        }

        if (userInformation.role == ROLES.PU) {
            getFunds();
        }

        if (
            user.role == ROLES.PU &&
            user.creator &&
            user.creator.promo_details &&
            user.creator.promo_details.promo_duration != 0
        ) {
            const duration = moment
                .utc(user.creator.promo_details.promo_start)
                .local()
                .add(user.creator.promo_details.promo_duration, "hours");
            setTimeLeft(duration);
        } else {
            setTimeLeft("No limit");
        }

        // Promo Code URL
        const promoUrlDetails = JSON.parse(localStorage.getItem("promo_url"));
        if (promoUrlDetails && promoUrlDetails.user.id === user.id) {
            // promo code here
            setPromoUrl(promoUrlDetails);
            let percent = calculatePercentage(
                promoUrlDetails.link_price,
                user.creator.subscription_price
            );
            setSavings(percent.toFixed(2).replace(".00", ""));
        }

        dispatch(setStashSelectedR([]));

        if (user.online_status) {
            dispatch(addChunkOnlinePresence([user.id]));
        }

        return () => {
            dispatch(setStashType("all"));
            dispatch(setStashSort("DESC"));
            dispatch(setFilterToDate(""));
            mounted = false;
        };
    }, []);

    useEffect(() => {
        let mounted = true;
        setOnShop(key === 2); // shop

        return () => {
            mounted = false;
            setOnShop(false);
        };
    }, [key]);

    const [lifeTimeBonusEarned, setLifeTimeBonusEarned] = useState(0);
    const getFunds = () => {
        setFundLoading(true);
        axios
            .get(`/api/user-funds`)
            .then((response) => {
                setFunds(response.data);
            })
            .catch((error) => {})
            .finally(() => {
                setFundLoading(false);
            });
    };

    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const handleSuccess = (status) => {
        setRefetch(true);
    };

    const [viewFund, setViewFund] = useState(false);
    const handleViewFund = () => setViewFund(!viewFund);

    const [viewBonus, setViewBonus] = useState(false);
    const handleViewBonus = () => setViewBonus(!viewBonus);

    const [cover, setCover] = useState("");
    const [isCheckingAvatar, setIsCheckingAvatar] = useState(false);
    const [vipBonus, setVipBonus] = useState(0);

    useEffect(() => {
        let mounted = true;
        let image = "";
        if (userStore.cover_pic) {
            image = `${s3Link}/${userStore.id}/cover_photo.jpg?t=${
                userStore.cover_photo_updated_at
                    ? userStore.cover_photo_updated_at
                    : new Date().valueOf()
            }`;
        }
        setCover(image);

        setLifeTimeBonusEarned(parseFloat(userStore.earnings_sum_amount));

        return () => {
            mounted = false;
        };
    }, [userStore]);

    const [lifeTimeBonus, setlifeTimeBonus] = useState(0);

    useEffect(() => {
        let mounted = true;
        // check user commission rate
        if (userStore.creator && userStore.creator.pu_commissionrate > 80) {
            // Calculation from CK: (myfunds/commision%) x (commission% - 80%)
            const userCommissionRate =
                parseFloat(userStore.creator.pu_commissionrate) / 100;
            const bonusRate =
                (parseFloat(funds) / userCommissionRate) *
                (userCommissionRate - 0.8);
            setVipBonus(bonusRate);

            const lifetimeBonusRate =
                ((parseFloat(userStore.creator.pu_commissionrate) - 80) / 100) *
                parseFloat(lifeTimeBonusEarned);
            setlifeTimeBonus(lifetimeBonusRate);
        }
        return () => {
            mounted = false;
        };
    }, [funds]);

    const maxWords = 6;
    const [shortCaption, setShortCaption] = useState("");

    const RenderCaption = ({ caption }) => {
        const [showMore, setShowMore] = useState(false);

        useEffect(() => {
            let mounted = true;

            setShortCaption(caption);

            return () => {
                mounted = false;
            };
        }, [caption]);

        const toggleShowCaption = (e) => {
            e.preventDefault();
            setShowMore((showMore) => !showMore);
        };

        const truncate = (str, no_words) => {
            const firstLine = str.split("\n");
            return firstLine[0].split(" ").splice(0, no_words).join(" ");
        };

        if (shortCaption && !showMore) {
            return (
                <React.Fragment>
                    <div
                        style={{ display: "inline", fontWeight: "normal" }}
                        dangerouslySetInnerHTML={{ __html: shortCaption }}
                    />{" "}
                    ...{" "}
                    <a href="#" onClick={toggleShowCaption}>
                        more
                    </a>
                </React.Fragment>
            );
        } else if (shortCaption && showMore) {
            return (
                <React.Fragment>
                    <div
                        style={{ display: "inline", fontWeight: "normal" }}
                        dangerouslySetInnerHTML={{ __html: caption }}
                    />{" "}
                    <a href="#" onClick={toggleShowCaption}>
                        less
                    </a>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div
                        style={{ display: "inline" }}
                        dangerouslySetInnerHTML={{ __html: caption }}
                    />
                </React.Fragment>
            );
        }
    };

    const RenderPromoUrl = () => {
        if (
            promoUrl &&
            Object.keys(promoUrl).length > 0 &&
            promoUrl.user.id === user.id
        ) {
            return (
                <div className="promo">
                    <div className="row">
                        <div
                            className="col-md-12"
                            style={{ padding: "15px 0", width: "fit-content" }}
                        >
                            <p className="promo-blue-header">
                                <b>
                                    Limited Offer {savings}% OFF! &nbsp;
                                    <span>
                                        {currency(promoUrl.link_price).format({
                                            currency: "",
                                            precision: 2,
                                        })}
                                    </span>{" "}
                                    USD for 1 month
                                </b>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        return "";
    };

    const [containerMax, setContainerMax] = useState(0);
    const [currentWidth, setCurrentWidth] = useState(0);
    const [willExpand, setWillExpand] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const profileBioContainerRef = useCallback((node) => {
        if (node) {
            setContainerMax(node.offsetWidth);
        }
    });

    useEffect(() => {
        const handleResize = () => {
            setContainerMax(containerMax);
            setCurrentWidth(containerMax);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        // check if body tag is on nut theme
        const onNutTheme = document.body.classList.contains("themeblk");
        if (onNutTheme && !darkmode) {
            // check if body has lightmode class
            if (document.body.classList.contains("lightmode")) {
                document.body.classList.remove("lightmode");
                document.body.classList.add("darkmode");
            }
        }
    }, [darkmode]);

    const handleEndTime = () => {};

    return (
        <>
            <MetaTags>
                <title>
                    {user.login} | Best way to make money as an influencer for
                    your exclusive content
                </title>
                <meta
                    name="description"
                    content={
                        user.login +
                        " is on Best way to make money as an influencer for your exclusive content. Join Best way to make money as an influencer for your exclusive content to view Karen7's profile"
                    }
                />
            </MetaTags>

            {viewFund ? (
                <Modal
                    className="fundModal"
                    size="md"
                    show={viewFund}
                    onHide={handleViewFund}
                    centered
                >
                    <Modal.Header>
                        <CloseButton
                            className="close"
                            onClick={handleViewFund}
                            style={{
                                position: "absolute",
                                top: "28px",
                                right: "12px",
                            }}
                        />
                        <Modal.Title className="text-center">
                            My funds
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="my_fund_text">
                            My Funds = Payments Received - Withdrawals for the
                            current month
                        </p>
                        <div className="my_fund_ul">
                            <span>
                                Payments = money received this month from all
                                payment sources (subscriptions + tips + PPV +
                                referral income)
                            </span>
                            <span>
                                This value is adjusted for your commission rate.
                            </span>
                            <span>
                                Withdrawals = money you have withdrawn during
                                the month
                            </span>
                            <span>
                                My Funds resets to 0 at the end of each month
                            </span>
                        </div>
                    </Modal.Body>
                </Modal>
            ) : null}
            {viewBonus ? (
                <Modal
                    className="fundModal"
                    size="md"
                    show={viewBonus}
                    onHide={handleViewBonus}
                    centered
                >
                    <Modal.Header>
                        <CloseButton
                            className="close"
                            onClick={handleViewBonus}
                            style={{
                                position: "absolute",
                                top: "28px",
                                right: "12px",
                            }}
                        />
                        <Modal.Title className="text-center">
                            Creator VIP Bonus
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="my_fund_text">
                            Congratulations you are receiving a VIP Bonus on all
                            of your sales! This includes subscriptions, PPV's
                            and tips!
                        </p>
                        <div className="my_fund_ul">
                            <span>
                                You are earning more than the standard 80% pay
                                rate.
                            </span>
                            <span>
                                This value shows how much extra you've earned
                                due to your higher pay rate this month.
                            </span>
                            <span>
                                This value is already included in your monthly
                                "My Funds" total i.e. this bonus is not paid out
                                separately and you don't have to request it
                                separately.
                            </span>
                        </div>
                        {/* <p className="my_fund_text mt-2">Total lifetime VIP bonus earned: {currency(lifeTimeBonus).format({ precision: 2 })}</p> */}
                    </Modal.Body>
                </Modal>
            ) : null}

            <div className="pu-profile-page-content">
                <Grid2 container spacing={!isMobile ? 2 : 0}>
                    <Grid2 md={8}>
                        <PSignupModal
                            showModal={show}
                            setShowModal={setShow}
                            user={user}
                        />

                        <div className="profile-container">
                            <div className={`profile-banner`}>
                                {!isCheckingAvatar && cover && (
                                    <LazyLoadImage src={cover} />
                                )}
                            </div>
                            <div className="profile-banner-details">
                                <div className="container">
                                    <div className="profile-user-info-container">
                                        <div className="profile-user-avatar-wrapper">
                                            <div className="profile-user-avatar">
                                                <Avatar
                                                    story={
                                                        user.stories_count > 0
                                                    }
                                                    pu={user}
                                                    size="150"
                                                    showOnline
                                                />
                                            </div>
                                        </div>
                                        <div className="profile-user-info-top">
                                            <div
                                                className={
                                                    user.firstname
                                                        ? "profile-user-name"
                                                        : "profile-user-name no-fn"
                                                }
                                            >
                                                <h4>
                                                    <b>{user.firstname}</b>{" "}
                                                    <span>
                                                        <LazyLoadImage
                                                            src={TickSmall}
                                                        />
                                                    </span>
                                                </h4>
                                                <p>@{user.login}</p>
                                            </div>
                                        </div>
                                        <div className="profile-user-info-bottom">
                                            <div className="profile-user-bottom-list pu-view">
                                                {isLoggedIn && (
                                                    <>
                                                        <div className="profile-user-btns-container">
                                                            <OverlayTrigger
                                                                defaultOverlayShown={
                                                                    true
                                                                }
                                                                delayHide={
                                                                    10000
                                                                }
                                                                overlay={
                                                                    <Tooltip
                                                                        placement="top"
                                                                        className="in"
                                                                        id="tooltip-top"
                                                                    >
                                                                        Edit
                                                                        Profile
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <a
                                                                    href="/edit-profile"
                                                                    className="edit-profile-btn"
                                                                >
                                                                    <span>
                                                                        <i className="fa-regular fa-gear"></i>
                                                                    </span>
                                                                </a>
                                                            </OverlayTrigger>

                                                            {user.creator &&
                                                                !user.creator
                                                                    .pause_status && (
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip
                                                                                placement="top"
                                                                                className="in"
                                                                                id="tooltip-top"
                                                                            >
                                                                                Promotion
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <a
                                                                            href="/promotion"
                                                                            className="promotion-btn"
                                                                        >
                                                                            <span>
                                                                                <i className="fa-regular fa-badge-percent"></i>
                                                                            </span>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                )}

                                                            {user.creator &&
                                                            user.creator
                                                                .pause_status ? (
                                                                <span className="account_paused">
                                                                    Account
                                                                    Paused
                                                                </span>
                                                            ) : (
                                                                ""
                                                            )}

                                                            <OverlayTrigger
                                                                overlay={
                                                                    <Tooltip
                                                                        placement="top"
                                                                        className="in"
                                                                        id="tooltip-top"
                                                                    >
                                                                        Copy
                                                                        Link
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <CopyToClipboard
                                                                    text={link}
                                                                    onCopy={() =>
                                                                        setShowToast(
                                                                            true
                                                                        )
                                                                    }
                                                                >
                                                                    <a className="copy-link-btn">
                                                                        <span>
                                                                            <i className="fa-regular fa-link-horizontal"></i>
                                                                        </span>
                                                                    </a>
                                                                </CopyToClipboard>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </>
                                                )}
                                                {!isLoggedIn && (
                                                    <div className="profile-user-btns-container">
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    placement="top"
                                                                    className="in"
                                                                    id="tooltip-top"
                                                                >
                                                                    Copy Link
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <CopyToClipboard
                                                                text={link}
                                                                onCopy={() =>
                                                                    setShowToast(
                                                                        true
                                                                    )
                                                                }
                                                            >
                                                                <a className="copy-link-btn">
                                                                    <span>
                                                                        <i className="fa-regular fa-link-horizontal"></i>
                                                                    </span>
                                                                </a>
                                                            </CopyToClipboard>
                                                        </OverlayTrigger>
                                                    </div>
                                                )}
                                            </div>
                                            {[ROLES.PU, ROLES.ADMIN].includes(
                                                user.role
                                            ) && <PStatistics user={user} />}
                                        </div>
                                    </div>

                                    <div
                                        className="profile-user-info-details"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div
                                            className={`bio-promo-container ${
                                                user.firstname ? "" : "no-fn"
                                            }`}
                                        >
                                            <div className="promo-container">
                                                {(!promoUrl ||
                                                    Object.keys(promoUrl)
                                                        .length <= 0) &&
                                                user.creator &&
                                                user.creator.promo_details &&
                                                Object.keys(
                                                    user.creator.promo_details
                                                ).length > 0 ? (
                                                    <div className="promo-content">
                                                        <p className="promo-blue-header">
                                                            <b>
                                                                Limited Offer{" "}
                                                                {
                                                                    user.creator
                                                                        .promo_details
                                                                        .save
                                                                }
                                                                % OFF! &nbsp;
                                                                <span>
                                                                    {currency(
                                                                        user
                                                                            .creator
                                                                            .promo_details
                                                                            .promo_price
                                                                    ).format({
                                                                        currency:
                                                                            "",
                                                                    })}
                                                                </span>{" "}
                                                                USD for 1 month
                                                            </b>
                                                        </p>
                                                        <div className="promo-end-count">
                                                            <h5>
                                                                Promo
                                                                ends:&nbsp;
                                                                <span className="blue_text">
                                                                    {timeLeft ===
                                                                    "No limit" ? (
                                                                        timeLeft
                                                                    ) : (
                                                                        <CountDownTimer
                                                                            dateTime={
                                                                                timeLeft
                                                                            }
                                                                            isUTC={
                                                                                true
                                                                            }
                                                                            onEndTime={
                                                                                handleEndTime
                                                                            }
                                                                        />
                                                                    )}
                                                                </span>
                                                            </h5>
                                                            <h5>
                                                                New Subscribers:{" "}
                                                                <span className="blue_text mr-3">
                                                                    {
                                                                        user
                                                                            .creator
                                                                            .promo_details
                                                                            .promo_limit_used
                                                                    }
                                                                </span>
                                                            </h5>
                                                            <h5>
                                                                <span>
                                                                    Promos left:{" "}
                                                                    <span className="blue_text">
                                                                        {user.creator &&
                                                                        user
                                                                            .creator
                                                                            .promo_details
                                                                            .promo_limit ==
                                                                            0
                                                                            ? "Unlimited"
                                                                            : parseInt(
                                                                                  user
                                                                                      .creator
                                                                                      .promo_details
                                                                                      .promo_limit
                                                                              ) -
                                                                              parseInt(
                                                                                  user
                                                                                      .creator
                                                                                      .promo_details
                                                                                      .promo_limit_used
                                                                              )}
                                                                    </span>
                                                                </span>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}

                                                {promoUrl &&
                                                    Object.keys(promoUrl)
                                                        .length > 0 && (
                                                        <RenderPromoUrl />
                                                    )}
                                            </div>

                                            <div className="container py-3">
                                                <div
                                                    ref={profileBioContainerRef}
                                                    className="profile-bio-container"
                                                >
                                                    <div
                                                        className="profile-bio-more"
                                                        style={{
                                                            whiteSpace:
                                                                isExpanded
                                                                    ? "pre-line"
                                                                    : "unset",
                                                        }}
                                                    >
                                                        {user.creator &&
                                                        user.creator
                                                            .pause_status &&
                                                        user.creator
                                                            .pause_text ? (
                                                            <div className="my-2">
                                                                {
                                                                    user.creator
                                                                        .pause_text
                                                                }
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        {user.creator &&
                                                            user.creator
                                                                .bio && (
                                                                <ReadMoreLess
                                                                    text={
                                                                        user
                                                                            .creator
                                                                            .bio
                                                                    }
                                                                    maxLength={
                                                                        55
                                                                    }
                                                                />
                                                            )}
                                                    </div>
                                                </div>

                                                {(() => {
                                                    if (isLoggedIn) {
                                                        return (
                                                            <div className="profile-user-funds-price">
                                                                <ul>
                                                                    <li>
                                                                        <span className="mr-1">
                                                                            <i className="fa-regular fa-gem" />
                                                                        </span>
                                                                        {fundLoading ? (
                                                                            <Spinner
                                                                                variant="primary"
                                                                                size="sm"
                                                                                animation="border"
                                                                            />
                                                                        ) : (
                                                                            <>
                                                                                <span>
                                                                                    {" "}
                                                                                    My
                                                                                    Funds:{" "}
                                                                                </span>
                                                                                <span className="font-blue">
                                                                                    {currency(
                                                                                        funds
                                                                                    ).format(
                                                                                        {
                                                                                            precision: 2,
                                                                                        }
                                                                                    )}
                                                                                </span>
                                                                                <a
                                                                                    onClick={
                                                                                        handleViewFund
                                                                                    }
                                                                                    className="ml-1"
                                                                                >
                                                                                    <i className="fa-solid fa-circle-question"></i>
                                                                                </a>
                                                                            </>
                                                                        )}
                                                                    </li>

                                                                    {/* {userStore.creator &&
                                                                        userStore
                                                                            .creator
                                                                            .pu_commissionrate >
                                                                            80 &&
                                                                        isLoggedIn ==
                                                                            userStore.id && (
                                                                            <li>
                                                                                <span className="mr-1">
                                                                                    <i className="fa-regular fa-sparkles" />
                                                                                </span>
                                                                                <span className="vip-label">
                                                                                    {" "}
                                                                                    VIP
                                                                                    Bonus:{" "}
                                                                                </span>
                                                                                <span className="vip-bonus">
                                                                                    {currency(
                                                                                        vipBonus
                                                                                    ).format(
                                                                                        {
                                                                                            precision: 2,
                                                                                        }
                                                                                    )}
                                                                                </span>
                                                                                <a
                                                                                    onClick={
                                                                                        handleViewBonus
                                                                                    }
                                                                                    className="vip-help ml-1"
                                                                                >
                                                                                    <i className="fa-solid fa-circle-question"></i>
                                                                                </a>
                                                                            </li>
                                                                        )} */}
                                                                    <li>
                                                                        <span className="mr-1">
                                                                            <i className="fa-regular fa-square-dollar"></i>
                                                                        </span>
                                                                        <span>
                                                                            {" "}
                                                                            My
                                                                            Price:{" "}
                                                                        </span>
                                                                        <span className="font-blue">
                                                                            $
                                                                            {user &&
                                                                            user.creator
                                                                                ? user
                                                                                      .creator
                                                                                      .subscription_price
                                                                                : "5"}
                                                                        </span>
                                                                        <span>
                                                                            /month
                                                                        </span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        );
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Toast message for copy profile link */}
                                <div className="profile-copy-link">
                                    <PRainbowToast
                                        show={showToast}
                                        setShow={setShowToast}
                                        message={`Copied Link to ${user.login} profile!`}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="container create-post-section">
                            {(() => {
                                if (isLoggedIn) {
                                    return (
                                        <div className="createpost-container">
                                            <PCreatePost
                                                schedule={false}
                                                successHandler={handleSuccess}
                                                activePost={activePost}
                                                onShop={onShop}
                                            />
                                        </div>
                                    );
                                }
                            })()}
                        </div>

                        <div
                            className={`container post-media-tabbed-container`}
                        >
                            <Tabs
                                value={key}
                                onChange={handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                aria-label="full width profile tabs"
                            >
                                <Tab
                                    className="profile-tab"
                                    label={
                                        <i className="fa-regular fa-photo-film"></i>
                                    }
                                    {...tabProps(0)}
                                />
                                <Tab
                                    className="profile-tab"
                                    label={
                                        <i className="fa-sharp fa-solid fa-grid"></i>
                                    }
                                    {...tabProps(1)}
                                />
                                <Tab
                                    className="profile-tab"
                                    label={
                                        <Badge
                                            anchorOrigin={{
                                                vertical: "top",
                                                horizontal: "right",
                                            }}
                                            sx={{
                                                "& .MuiBadge-badge": {
                                                    backgroundColor:
                                                        "transparent",
                                                    color: "#0097fe",
                                                    fontWeight: "bold",
                                                    right: "-16px",
                                                },
                                            }}
                                            badgeContent="NEW"
                                        >
                                            <i className="fa-regular fa-cart-shopping"></i>
                                        </Badge>
                                    }
                                    {...tabProps(2)}
                                />
                            </Tabs>
                            <div id="pu-content-container">
                                <TabPanel value={key} index={0}>
                                    <PostsContent
                                        refetch={refetch}
                                        setRefetch={setRefetch}
                                        isPu={isPu}
                                        user={user}
                                    />
                                </TabPanel>
                                <TabPanel value={key} index={1}>
                                    <MediaContent
                                        refetch={refetch}
                                        setRefetch={setRefetch}
                                        isPu={isPu}
                                        user={user}
                                    />
                                </TabPanel>
                                <TabPanel value={key} index={2}>
                                    <ShopContents
                                        refetch={refetch}
                                        setRefetch={setRefetch}
                                        isPu={isPu}
                                        user={user}
                                    />
                                </TabPanel>
                            </div>
                        </div>
                    </Grid2>

                    <Grid2 className="su-homepage__right" md={4}>
                        {userInformation && userInformation.role == ROLES.SU ? (
                            <DefaultWidget />
                        ) : null}
                        {userInformation && userInformation.role == ROLES.PU ? (
                            <DefaultPUWidget />
                        ) : null}
                    </Grid2>
                </Grid2>
            </div>
        </>
    );
};

function mapStateToProps(state) {
    return {
        darkmode: state.privaGlobal.darkmode,
        activePost: state.privaGlobal.selectedPost,
        userStore: state.user.user,
    };
}

export default connect(mapStateToProps)(React.memo(PUPageContent));
